function _(n,t,o){var r=n(74),u=n(29);t.exports=function(n){return u(n)?n:r(n,"Cannot use %v",arguments[1])}}
//# sourceMappingURL=ensure.min.js.map